<div class="main-layout">
  <div class="main-header-container">
    <app-quotation-top-header></app-quotation-top-header>
    <app-quotation-header (collapsedState)="onHeaderCollapse($event)"></app-quotation-header>
  </div>

  <div class="content-wrapper" [class.expanded]="!isHeaderCollapsed" [class.collapsed]="isHeaderCollapsed">
    <div class="quotation-list-container">
      <div class="header-container">
        <h2 class="header-title executive">
          <i class="pi pi-th-large title-icon"></i>
          Enclosure Projects
        </h2>

        <div class="action-toolbar">
          <!-- Primary Actions -->
          <div class="primary-actions">
            <button pButton type="button" icon="pi pi-plus" (click)="openNewDialog()" class="p-button-primary"
              pTooltip="New Project" tooltipPosition="top">
            </button>
          </div>

          <!-- Export Actions Group -->
          <div class="export-group">
            <!-- Export Selected Items to Excel -->
            <button pButton type="button" icon="pi pi-file-excel" class="p-button-success"
              [disabled]="!selectedWorkflowItems.length || isGeneratingExcel" (click)="exportToExcel()"
              pTooltip="Export Selected Items to Excel ({{selectedWorkflowItems.length}})" tooltipPosition="top">
            </button>

            <!-- Export Successful Orders -->
            <button pButton type="button" icon="pi pi-check-circle" class="p-button-info"
              [disabled]="!filteredWorkflowItems.length || isGeneratingExcel" (click)="exportFilteredToExcel()"
              pTooltip="Export Success Orders ({{filteredWorkflowItems.length}})" tooltipPosition="top">
            </button>

            <!-- Export All Data -->
            <button pButton type="button" icon="pi pi-database" class="p-button-secondary"
              [disabled]="!workflowItems.length || isGeneratingExcel" (click)="exportAllToExcel()"
              pTooltip="Export Complete Dataset ({{workflowItems.length || 0}})" tooltipPosition="top">
            </button>

            <!-- Export Lost Orders (Items without PO) -->
            <button pButton type="button" icon="pi pi-exclamation-triangle" class="p-button-warning"
              [disabled]="isGeneratingExcel || getItemsWithoutPoCount() === 0" (click)="exportItemsWithoutPoNumber()"
              pTooltip="Export Lost Orders - No PO Number ({{getItemsWithoutPoCount()}})" tooltipPosition="top">
            </button>
          </div>

          <!-- Document Actions -->
          <div class="document-actions">
            <button pButton type="button" icon="pi pi-file-pdf" class="p-button-warning"
              [disabled]="!selectedWorkflowItems.length || isGeneratingPDF" (click)="generatePDF()"
              pTooltip="Generate PDF Report for Selected Items" tooltipPosition="top">
            </button>
          </div>

          <!-- Destructive Actions -->
          <div class="danger-actions">
            <button pButton type="button" icon="pi pi-trash" class="p-button-danger"
              [disabled]="!selectedWorkflowItems.length" (click)="deleteSelectedWorkflows()"
              pTooltip="Delete Selected Items ({{selectedWorkflowItems.length}})" tooltipPosition="top">
            </button>
          </div>

          <!-- Admin Actions -->
          <div class="admin-actions">
            <button pButton icon="pi pi-times-circle" *ngIf="userDetails?.role === 'superadmin'" (click)="clearTables()"
              [disabled]="isClearing" class="p-button-danger p-button-outlined"
              pTooltip="Clear All Data Tables (Admin Only)" tooltipPosition="top">
            </button>

            <label class="custom-file-upload" pTooltip="Upload Excel File to Import Data" tooltipPosition="top">
              <i class="pi pi-upload"></i>
              <input type="file" accept=".xlsx,.xls" (change)="onFileUpload($event)" hidden />
            </label>
          </div>
          <div class="filter-section">
            <p-dropdown [options]="filterOptions" [(ngModel)]="selectedFilter" optionLabel="label" optionValue="value"
              (onChange)="onFilterChange($event)" placeholder="Filter by Type" styleClass="filter-dropdown"
              [showClear]="false">
            </p-dropdown>
            <span class="filter-count">({{filteredWorkflowItems.length}})</span>
          </div>
          <!-- Filter Stats (Drawing & Encloser only) -->
          <div class="filter-stats" *ngIf="selectedFilter === 'drawing' || selectedFilter === 'encloser'">
            <!-- Drawing Stats -->
            <div class="drawing-stats" *ngIf="selectedFilter === 'drawing'">
              <div class="stat-card po-stats">
                <i class="pi pi-shopping-cart stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">PO Value</span>
                  <span class="stat-value">{{getDrawingPoTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>

              <div class="stat-card invoice-stats">
                <i class="pi pi-file-invoice stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">Invoices</span>
                  <span class="stat-value">{{getDrawingInvoiceTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>

              <div class="stat-card payment-stats">
                <i class="pi pi-money-bill stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">Payments</span>
                  <span class="stat-value">{{getDrawingPaymentTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>
            </div>

            <!-- Encloser Stats -->
            <div class="encloser-stats" *ngIf="selectedFilter === 'encloser'">
              <div class="stat-card po-stats">
                <i class="pi pi-shopping-cart stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">PO Value</span>
                  <span class="stat-value">{{getEncloserPoTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>

              <div class="stat-card invoice-stats">
                <i class="pi pi-file-invoice stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">Invoices</span>
                  <span class="stat-value">{{getEncloserInvoiceTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>

              <div class="stat-card payment-stats">
                <i class="pi pi-money-bill stat-icon"></i>
                <div class="stat-info">
                  <span class="stat-label">Payments</span>
                  <span class="stat-value">{{getEncloserPaymentTotal() | currency:'LKR':'symbol':'1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Loading Overlay -->
          <div class="toolbar-loading-overlay" *ngIf="isGeneratingExcel || isGeneratingPDF || isClearing">
            <div class="loading-spinner"></div>
          </div>
        </div>
        <p-toast></p-toast>
        <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
        <!-- Global Loading Overlay -->
        <div *ngIf="loading" class="loading-overlay">
          <div class="loading-content">
            <p-progressSpinner></p-progressSpinner>
            <p>Loading data...</p>
          </div>
        </div>
        <p-tabView class="custom-tabview">
          <p-tabPanel header="All Documents">
            <p-table #dt [value]="filteredWorkflowItems" [loading]="tabLoadingStates.all" [paginator]="true" [rows]="50"
              scrollHeight="400px" [scrollable]="true"
              [globalFilterFields]="['orderId', 'quotationNo', 'customerName', '', 'poNumber', 'proformaInvoice', 'jobNumber', 'displayInvoices', 'displayPayments', 'email', 'methodOfInquiryReceived', 'country']"
              [rowsPerPageOptions]="[10, 25, 50]" [showCurrentPageReport]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              styleClass="p-datatable-responsive" [(selection)]="selectedWorkflowItems" rowSelectMode="checkbox"
              class="custom-main-table" [sortField]="'jobNumber'" [sortOrder]="-1">
              <ng-template pTemplate="caption">
                <div class="p-d-flex p-jc-between p-ai-center caption-container">

                  <!-- LEFT: Search (onGlobalFilter) -->
                  <span class="p-input-icon-left search-container">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search..." />
                  </span>

                  <!-- RIGHT: Filter Container -->
                  <div class="filter-container p-d-flex p-ai-center">
                    <p-dropdown [options]="dateFilterOptions" [(ngModel)]="selectedDateFilterType" optionLabel="label"
                      optionValue="value" placeholder="Filter By" class="custom-dropdown"
                      (onChange)="onDateFilterTypeChange()">
                    </p-dropdown>

                    <p-calendar [(ngModel)]="dateRange" selectionMode="range" [showIcon]="true" class="custom-calander"
                      placeholder="Select Date Range" dateFormat="mm/dd/yy" appendTo="body" [readonlyInput]="false"
                      (onSelect)="applyDateRangeFilter()" (onClearClick)="clearDateRangeFilter()">
                    </p-calendar>

                    <button pButton type="button" label="Clear" class="p-button-secondary"
                      (click)="clearDateRangeFilter()">
                    </button>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr class="bg-gray-100">
                  <th style="width: 3rem" class="p-3">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                  </th>
                  <th>Quotation No.</th>
                  <th pSortableColumn="quotationDate">Received Date<p-sortIcon field="quotationDate"></p-sortIcon></th>
                  <th>Customer</th>
                  <th>Project</th>
                  <th>PO Number</th>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="jobNumber"></p-sortIcon></th>
                  <th>Invoices</th>
                  <th>Payments</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr class="hover:bg-gray-50 transition-colors">
                  <td class="p-3">
                    <p-tableCheckbox [value]="item"></p-tableCheckbox>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Quotation No.:</span>
                    <span class="text-sm">{{ item.quotationNo || 'Update Quotation No' }}</span>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Received Date:</span>
                    <span class="text-sm">{{ item.quotationDate | date:'MM/dd/yyyy' }}</span>
                  </td>
                  <td class="p-3 bg-blue-50">
                    <span class="p-column-title">Customer:</span>
                    <p-overlayPanel #opCustomer *ngIf="item.customerName && item.customerName.length > 25">
                      <ng-template pTemplate>
                        <div class="p-3 max-w-md">
                          <h3 class="font-semibold mb-2">Customer Details</h3>
                          <p>{{ item.customerName }}</p>
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                    <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                      [pTooltip]="item.customerName && item.customerName.length > 25 ? 'View full customer name' : ''"
                      (click)="item.customerName && item.customerName.length > 25 ? opCustomer.toggle($event) : null">
                      {{ item.customerName && item.customerName.length > 25 ? (item.customerName | slice:0:25) + '...' :
                      (item.customerName || '-') }}
                    </span>
                  </td>
                  <td class="p-3 bg-blue-50">
                    <span class="p-column-title">Project:</span>
                    <div class="flex items-center">
                      <p-overlayPanel #opProject *ngIf="item.project && item.project.length > 25">
                        <ng-template pTemplate>
                          <div class="p-3 max-w-md">
                            <h3 class="font-semibold mb-2">Project Details</h3>
                            <p>{{ item.project }}</p>
                          </div>
                        </ng-template>
                      </p-overlayPanel>
                      <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                        [pTooltip]="item.project && item.project.length > 25 ? 'View full project name' : ''"
                        (click)="item.project && item.project.length > 25 ? opProject.toggle($event) : null">
                        {{ item.project && item.project.length > 25 ? (item.project | slice:0:25) + '...' :
                        (item.project
                        || '-') }}
                      </span>
                    </div>
                  </td>
                  <td class="p-3 bg-blue-50">
                    <span class="p-column-title">PO Number:</span>
                    <p-overlayPanel #opPoNumber *ngIf="item.poNumber && item.poNumber.length > 20">
                      <ng-template pTemplate>
                        <div class="p-3 max-w-md">
                          <h3 class="font-semibold mb-2">PO Number</h3>
                          <p>{{ item.poNumber }}</p>
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                    <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                      [pTooltip]="item.poNumber && item.poNumber.length > 20 ? 'View full PO number' : ''"
                      (click)="item.poNumber && item.poNumber.length > 20 ? opPoNumber.toggle($event) : null">
                      {{ item.poNumber && item.poNumber.length > 20 ? (item.poNumber | slice:0:20) + '...' :
                      (item.poNumber || 'N/A') }}
                    </span>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Job Number:</span>
                    <span class="text-sm">{{ item.jobNumber || 'N/A' }}</span>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Invoices:</span>
                    <p-overlayPanel #opInvoices>
                      <ng-template pTemplate>
                        <div class="p-3 max-w-md">
                          <h3 class="font-semibold mb-2">Invoices</h3>
                          <div *ngFor="let inv of item.invoices" class="mb-1">
                            {{ inv.invoiceNo }}: {{ inv.invoicePrice | currency:'USD':'symbol':'1.2-2' }}
                          </div>
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                    <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                      (click)="opInvoices.toggle($event)">
                      {{ item.displayInvoices || 'N/A' | slice:0:20 }}{{ item.displayInvoices?.length > 20 ? '...' : ''
                      }}
                    </span>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Payments:</span>
                    <p-overlayPanel #opPayments>
                      <ng-template pTemplate>
                        <div class="p-3 max-w-md">
                          <h3 class="font-semibold mb-2">Payments</h3>
                          <div *ngFor="let pay of item.payments" class="mb-1">
                            {{ pay.invoiceNo || 'Update Invoice No' }}: {{ pay.paymentPrice |
                            currency:'USD':'symbol':'1.2-2' }}
                          </div>
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                    <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                      (click)="opPayments.toggle($event)">
                      {{ item.displayPayments || 'Not received' | slice:0:20 }}{{ item.displayPayments?.length > 20 ?
                      '...' : '' }}
                    </span>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Email:</span>
                    <div class="flex items-center">
                      <span *ngIf="item.showEmail; else hiddenEmail" class="text-sm">{{ item.email || '-' }}</span>
                      <ng-template #hiddenEmail><span class="text-sm">***</span></ng-template>
                      <button pButton type="button" icon="{{ item.showEmail ? 'pi pi-eye-slash' : 'pi pi-eye' }}"
                        class="p-button-text p-button-sm ml-2" (click)="toggleEmailVisibility(item)"
                        pTooltip="Toggle Email" tooltipPosition="top"></button>
                    </div>
                  </td>
                  <td class="p-3">
                    <span class="p-column-title">Status:</span>
                    <p-badge [value]="getWorkflowStatus(item)" [severity]="getStatusSeverity(item)"
                      styleClass="text-sm"></p-badge>
                  </td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil"
                        class="p-button-rounded p-button-success p-button-sm" (click)="editWorkflow(item)"
                        pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-danger p-button-sm" (click)="deleteWorkflow(item)"
                        pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="15" class="text-center p-6 text-gray-500">
                    No documents found. Click 'New Quotation' or upload an Excel file to populate the table.
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Quotations">
            <p-table [value]="getFilteredItems('quotation')" [loading]="tabLoadingStates.quotations" [paginator]="true"
              [rows]="50" scrollHeight="400px" [scrollable]="true" styleClass="p-datatable-responsive"
              class="custom-table" [sortField]="'quotationDate'" [sortOrder]="-1">
              <ng-template pTemplate="header">
                <tr>
                  <th>Quotation No.</th>
                  <th>Date</th>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="jobNumber"></p-sortIcon></th>
                  <th>Customer</th>
                  <th>Project</th>
                  <th>Total Price</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td><span class="p-column-title">Quotation No.:</span>{{item.quotationNo}}</td>
                  <td><span class="p-column-title">Date:</span>{{item.quotationDate || item.date | date}}</td>
                  <td class="p-3">
                    <span class="p-column-title">Job Number:</span>
                    <span class="text-sm">{{ item.jobNumber || 'N/A' }}</span>
                  </td>
                  <td><span class="p-column-title">Customer:</span>{{item.customerName}}</td>
                  <td><span class="p-column-title">Project:</span>{{item.project}}</td>
                  <td><span class="p-column-title">Total Price:</span>{{item.totalPrice |
                    currency:'USD':'symbol':'1.2-2'}}
                  </td>
                  <td><span class="p-column-title">Email:</span>{{item.email || 'N/A'}}</td>
                  <td><span class="p-column-title">Country:</span>{{item.country || 'N/A'}}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'quotation')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>

                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" class="text-center">No quotations found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Purchase Orders">
            <p-table [value]="getFilteredItems('po')" [loading]="tabLoadingStates.po" scrollHeight="400px"
              [scrollable]="true" [paginator]="true" [rows]="50" styleClass="p-datatable-responsive"
              class="custom-table" [sortField]="'poDate'" [sortOrder]="-1">
              <ng-template pTemplate="header">
                <tr>
                  <th>PO Number</th>
                  <th>Date</th>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="jobNumber"></p-sortIcon></th>
                  <th>Customer</th>
                  <th>Related Quotation</th>
                  <th>Total Price</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td><span class="p-column-title">PO Number:</span>{{item.poNumber}}</td>
                  <td><span class="p-column-title">Date:</span>{{item.poDate | date}}</td>
                  <td class="p-3">
                    <span class="p-column-title">Job Number:</span>
                    <span class="text-sm">{{ item.jobNumber || 'N/A' }}</span>
                  </td>
                  <td><span class="p-column-title">Customer:</span>{{item.customerName}}</td>
                  <td><span class="p-column-title">Related Quotation:</span>{{item.quotationNo}}</td>
                  <td><span class="p-column-title">Total Price:</span>{{item.totalPrice |
                    currency:'USD':'symbol':'1.2-2'}}
                  </td>
                  <td><span class="p-column-title">Email:</span>{{item.email || 'N/A'}}</td>
                  <td><span class="p-column-title">Country:</span>{{item.country || 'N/A'}}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'po')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" class="text-center">No purchase orders found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Proforma Invoices">
            <p-table [value]="getFilteredItems('pi')" [loading]="tabLoadingStates.pi" scrollHeight="400px"
              [scrollable]="true" [paginator]="true" [rows]="50" styleClass="p-datatable-responsive"
              class="custom-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>PI Number</th>
                  <th>Date</th>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="jobNumber"></p-sortIcon></th>
                  <th>Customer</th>
                  <th>Related PO</th>
                  <th>Related Quotation</th>
                  <th>Total Price</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td><span class="p-column-title">PI Number:</span>{{item.proformaInvoice}}</td>
                  <td><span class="p-column-title">Date:</span>{{item.piDate | date}}</td>
                  <td class="p-3">
                    <span class="p-column-title">Job Number:</span>
                    <span class="text-sm">{{ item.jobNumber || 'N/A' }}</span>
                  </td>
                  <td><span class="p-column-title">Customer:</span>{{item.customerName}}</td>
                  <td><span class="p-column-title">Related PO:</span>{{item.poNumber}}</td>
                  <td><span class="p-column-title">Related Quotation:</span>{{item.quotationNo}}</td>
                  <td><span class="p-column-title">Total Price:</span>{{item.totalPrice |
                    currency:'USD':'symbol':'1.2-2'}}
                  </td>
                  <td><span class="p-column-title">Email:</span>{{item.email || 'N/A'}}</td>
                  <td><span class="p-column-title">Country:</span>{{item.country || 'N/A'}}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'pi')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="10" class="text-center">No proforma invoices found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Work Orders">
            <p-table [value]="getFilteredItems('workOrder')" [loading]="tabLoadingStates.workOrder" scrollHeight="400px"
              [scrollable]="true" [paginator]="true" [rows]="50" styleClass="p-datatable-responsive"
              class="custom-table" [sortField]="'jobNumber'" [sortOrder]="-1">
              <ng-template pTemplate="header">
                <tr>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="item.jobNumber"></p-sortIcon></th>
                  <th>Customer</th>
                  <th>Project</th>
                  <th>Related PO</th>
                  <th>Related Quotation</th>
                  <th>Total Price</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td><span class="p-column-title">Job Number:</span>{{ item.jobNumber }}</td>
                  <td>
                    <span class="p-column-title">Customer:</span>
                    <span *ngIf="item.showFullCustomerName; else truncatedCustomer">{{
                      item.customerName || '-'
                      }}</span>
                    <ng-template #truncatedCustomer>
                      {{ item.customerName && item.customerName.length > 7 ? (item.customerName | slice:0:7) + '...' :
                      (item.customerName || 'Update customer name') }}
                    </ng-template>
                    <button *ngIf="item.customerName && item.customerName.length > 7" pButton type="button"
                      [icon]="item.showFullCustomerName ? 'pi pi-eye-slash' : 'pi pi-eye'"
                      class="p-button-text p-button-sm p-ml-2" (click)="toggleCustomerNameVisibility(item)"
                      pTooltip="Toggle Customer Name Visibility" tooltipPosition="top"></button>
                  </td>
                  <td>
                    <span class="p-column-title">Project:</span>
                    <span *ngIf="item.showFullProjectName; else truncatedProject">{{
                      item.project || 'Update project name'
                      }}</span>
                    <ng-template #truncatedProject>
                      {{ item.project && item.project.length > 15 ? (item.project | slice:0:15) + '...' : (item.project
                      ||
                      '-') }}
                    </ng-template>
                    <button *ngIf="item.project && item.project.length > 15" pButton type="button"
                      [icon]="item.showFullProjectName ? 'pi pi-eye-slash' : 'pi pi-eye'"
                      class="p-button-text p-button-sm p-ml-2" (click)="toggleProjectNameVisibility(item)"
                      pTooltip="Toggle Project Name Visibility" tooltipPosition="top"></button>
                  </td>
                  <td><span class="p-column-title">Related PO:</span>{{ item.poNumber }}</td>
                  <td><span class="p-column-title">Related Quotation:</span>{{ item.quotationNo }}</td>
                  <td>
                    <span class="p-column-title">Total Price:</span>
                    {{ item.totalPrice | currency:'USD':'symbol':'1.2-2' }}
                  </td>
                  <td>
                    <span class="p-column-title">Email:</span>
                    <span *ngIf="item.showEmail; else hiddenEmail">{{
                      item.email || 'N/A'
                      }}</span>
                    <ng-template #hiddenEmail>
                      {{ item.email && item.email.length > 3 ? (item.email | slice:0:3) + '...' : (item.email || '-') }}
                    </ng-template>
                    <button *ngIf="item.email && item.email.length > 3" pButton type="button"
                      [icon]="item.showEmail ? 'pi pi-eye-slash' : 'pi pi-eye'" class="p-button-text p-button-sm p-ml-2"
                      (click)="toggleEmailVisibility(item)" pTooltip="Toggle Email Visibility"
                      tooltipPosition="top"></button>
                  </td>
                  <td><span class="p-column-title">Country:</span>{{ item.country || 'N/A' }}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-cog" class="p-button-rounded p-button-info p-mr-2"
                        (click)="openStatusDialog(item)" pTooltip="Status" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'workOrder')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="10" class="text-center">No work orders found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Commercial Invoices">
            <p-table [value]="getFilteredItems('ci')" [loading]="tabLoadingStates.ci" scrollHeight="400px"
              [scrollable]="true" [paginator]="true" [rows]="50" styleClass="p-datatable-responsive"
              class="custom-table">
              <ng-template pTemplate="header">
                <tr>
                  <th>Invoices</th>
                  <th>Job Number</th>
                  <th>Customer</th>
                  <th>Total Invoiced</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td class="p-3">
                    <span class="p-column-title">Invoices:</span>
                    <p-overlayPanel #opInvoices>
                      <ng-template pTemplate>
                        <div class="p-3 max-w-md">
                          <h3 class="font-semibold mb-2">Invoices</h3>
                          <div *ngFor="let inv of item.invoices" class="mb-1">
                            {{ inv.invoiceNo }}: {{ inv.invoicePrice | currency:'USD':'symbol':'1.2-2' }}
                          </div>
                        </div>
                      </ng-template>
                    </p-overlayPanel>
                    <span class="text-sm cursor-pointer text-blue-600 hover:underline"
                      (click)="opInvoices.toggle($event)">
                      {{ item.displayInvoices || 'N/A' | slice:0:20 }}{{ item.displayInvoices?.length > 20 ? '...' : ''
                      }}
                    </span>
                  </td>
                  <td><span class="p-column-title">Job Number:</span>{{item.jobNumber}}</td>
                  <td><span class="p-column-title">Customer:</span>{{item.customerName}}</td>
                  <td><span class="p-column-title">Total Invoiced:</span>{{item.totalInvoiceAmount |
                    currency:'USD':'symbol':'1.2-2' }}</td>
                  <td><span class="p-column-title">Email:</span>{{item.email || '-'}}</td>
                  <td><span class="p-column-title">Country:</span>{{item.country || '-'}}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'ci')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="9" class="text-center">No commercial invoices found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

          <p-tabPanel header="Payments">
            <p-table [value]="getFilteredItems('payment')" [loading]="tabLoadingStates.payment" [paginator]="true"
              [rows]="50" styleClass="p-datatable-responsive" class="custom-table" scrollHeight="400px">

              <ng-template pTemplate="header">
                <tr>
                  <th>Payments</th>
                  <th>PO Number</th>
                  <th pSortableColumn="jobNumber">Job Number<p-sortIcon field="jobNumber"></p-sortIcon></th>
                  <th>
                    Payment Status
                    <p-columnFilter type="text" field="paymentStatusText" display="menu" [showMatchModes]="false"
                      [showOperator]="false" [showAddButton]="false">

                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown [ngModel]="value" (ngModelChange)="filter($event)" [options]="paymentStatusOptions"
                          placeholder="Select Status" optionLabel="label" optionValue="value" [showClear]="true"
                          appendTo="body">
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>
                  <th>Total Paid</th>
                  <th>Outstanding</th>
                  <th>Email</th>
                  <th>Country</th>
                  <th>Actions</th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-item>
                <tr>
                  <td><span class="p-column-title">Payments:</span>{{item.displayPayments || '-'}}</td>
                  <td><span class="p-column-title">PO Number:</span>{{item.poNumber}}</td>
                  <td class="p-3">
                    <span class="p-column-title">Job Number:</span>
                    <span class="text-sm">{{ item.jobNumber || 'N/A' }}</span>
                  </td>
                  <td>
                    <span class="p-column-title">Payment Status:</span>
                    <span [style.color]="item.isPaymentCompleted ? 'green' : 'orange'">
                      {{ item.paymentStatusText }}
                    </span>
                    <i *ngIf="item.isPaymentCompleted" class="pi pi-check-circle"
                      style="color: green; margin-left: 5px;"></i>
                  </td>
                  <td>
                    <span class="p-column-title">Total Paid:</span>
                    {{ item.totalPaymentAmount | currency:'USD'}}
                  </td>
                  <td>
                    <span class="p-column-title">Outstanding:</span>
                    {{ item.outstandingAmount | currency:'USD'}}
                  </td>
                  <td><span class="p-column-title">Email:</span>{{item.email || '-'}}</td>
                  <td><span class="p-column-title">Country:</span>{{item.country || '-'}}</td>
                  <td class="p-3">
                    <div class="flex gap-2">
                      <button pButton type="button" icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                        (click)="editWorkflow(item, 'payment')" pTooltip="Edit" tooltipPosition="top"></button>
                      <button pButton type="button" icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteWorkflow(item)" pTooltip="Delete" tooltipPosition="top"></button>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="8" class="text-center">No payments found.</td>
                </tr>
              </ng-template>
            </p-table>
          </p-tabPanel>

        </p-tabView>
        <!-- Enhanced Upload Dialog with Progress Content -->
        <p-dialog header="Uploading Excel File" [(visible)]="showUploadDialog" [modal]="true" [closable]="!isUploading"
          [draggable]="false" [resizable]="false" styleClass="upload-progress-dialog" [style]="{width: '450px'}"
          (onHide)="closeUploadDialog()">

          <div class="upload-progress-content">
            <!-- Warning Message -->
            <div class="warning-message" *ngIf="isUploading">
              <i class="pi pi-exclamation-triangle" style="color: var(--orange-500);"></i>
              <span><strong>Important:</strong> Please do not close this window or refresh the page while the upload is
                in
                progress.</span>
            </div>

            <!-- File Info -->
            <div class="file-info" *ngIf="uploadedFileName">
              <i class="pi pi-file-excel" style="font-size: 2rem; color: var(--green-500);"></i>
              <div class="file-details">
                <strong>{{ uploadedFileName }}</strong>
                <p>Processing Excel file...</p>
              </div>
            </div>

            <!-- Progress Bar - Enhanced visibility -->
            <div class="progress-section" *ngIf="showUploadDialog && (isUploading || uploadProgress > 0)">
              <!-- Debug info - remove this after testing -->
              <div style="margin-bottom: 10px; font-size: 12px; color: #666;">
                Progress: {{ uploadProgress }}% | Uploading: {{ isUploading }}
              </div>

              <div class="progress-container">
                <p-progressBar [value]="uploadProgress" [showValue]="true" styleClass="upload-progress-bar"
                  [style]="{height: '20px', width: '100%'}">
                </p-progressBar>
              </div>

              <!-- Status Message -->
              <div class="status-message">
                <span>{{ uploadStatus }}</span>
                <i class="pi pi-spin pi-spinner" *ngIf="isUploading"></i>
              </div>
            </div>

            <!-- Success Message -->
            <div class="success-message" *ngIf="uploadProgress === 100 && !isUploading">
              <i class="pi pi-check-circle" style="color: var(--green-500);"></i>
              <span>Upload completed successfully!</span>
            </div>

            <!-- Error Message -->
            <div class="error-message" *ngIf="uploadError">
              <i class="pi pi-exclamation-triangle" style="color: var(--red-500);"></i>
              <span>{{ uploadError }}</span>
            </div>
          </div>

          <!-- Dialog Footer -->
          <ng-template pTemplate="footer">
            <div class="dialog-footer">
              <button pButton type="button" label="Close" class="p-button-secondary" [disabled]="isUploading"
                (click)="closeUploadDialog()">
              </button>
            </div>
          </ng-template>
        </p-dialog>

        <!-- Conflict Resolution Dialog - Corrected Version -->
        <p-dialog header="Data Conflicts Detected" [(visible)]="showConflictDialog" [modal]="true"
          [closable]="!isProcessingConflicts" [draggable]="false" [resizable]="true" styleClass="conflict-dialog"
          [style]="{width: '90vw', height: '80vh'}" (onHide)="cancelConflictResolution()">

          <div class="conflict-dialog-content">
            <div class="conflict-header">
              <p>The following records already exist in the database. Select which ones you want to update:</p>
              <div class="selection-controls">
                <p-checkbox [(ngModel)]="selectAllConflicts" (onChange)="toggleAllSelections($event.checked)"
                  label="Select All" [binary]="true"></p-checkbox>
                <span class="selected-count">{{ getSelectedCount() }} of {{ conflictItems.length }} selected</span>
              </div>
            </div>

            <div class="conflict-table-container">
              <p-table [value]="conflictItems" [scrollable]="true" scrollHeight="400px" styleClass="conflict-table">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 50px;">Select</th>
                    <th style="width: 150px;">Quotation No</th>
                    <th style="width: 200px;">Customer</th>
                    <th style="min-width: 300px;">Changes</th>
                    <th style="width: 150px;">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr>
                    <td>
                      <p-checkbox [binary]="true" [(ngModel)]="item.selected"></p-checkbox>
                    </td>
                    <td>
                      <strong>{{ item.quotationNo }}</strong>
                    </td>
                    <td>
                      {{ item.newData.customerName || item.existingData.customerName }}
                    </td>
                    <td>
                      <div class="changes-list">
                        <div *ngFor="let conflict of item.conflicts" class="change-item">
                          <span class="field-name">{{ getFieldDisplayName(conflict) }}:</span>

                          <!-- Special handling for array fields -->
                          <div class="value-comparison" *ngIf="isArrayField(conflict); else normalField">
                            <div class="array-comparison">
                              <!-- Existing Array Data -->
                              <div class="array-section">
                                <span class="array-label">Existing:</span>
                                <div class="array-items">
                                  <div *ngIf="getArrayValue(item.existingData[conflict]).length === 0"
                                    class="empty-array">
                                    No items
                                  </div>
                                  <div *ngFor="let arrayItem of getArrayValue(item.existingData[conflict])"
                                    class="array-item">
                                    {{ formatArrayItem(conflict, arrayItem) }}
                                  </div>
                                </div>
                              </div>

                              <i class="pi pi-arrow-right array-arrow"></i>

                              <!-- New Array Data -->
                              <div class="array-section">
                                <span class="array-label">New:</span>
                                <div class="array-items">
                                  <div *ngIf="getArrayValue(item.newData[conflict]).length === 0" class="empty-array">
                                    No items
                                  </div>
                                  <div *ngFor="let arrayItem of getArrayValue(item.newData[conflict])"
                                    class="array-item">
                                    {{ formatArrayItem(conflict, arrayItem) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Normal field comparison -->
                          <ng-template #normalField>
                            <div class="value-comparison">
                              <span class="old-value">{{ getDisplayValue(item.existingData[conflict]) }}</span>
                              <i class="pi pi-arrow-right"></i>
                              <span class="new-value">{{ getDisplayValue(item.newData[conflict]) }}</span>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </td>
                    <td>
                      <button pButton type="button" [icon]="item.selected ? 'pi pi-check' : 'pi pi-times'"
                        [class]="item.selected ? 'p-button-success' : 'p-button-secondary'"
                        [label]="item.selected ? 'Will Update' : 'Skip'" (click)="item.selected = !item.selected"
                        size="small">
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>

          <ng-template pTemplate="footer">
            <div class="dialog-footer">
              <button pButton type="button" label="Cancel" class="p-button-secondary" [disabled]="isProcessingConflicts"
                (click)="cancelConflictResolution()">
              </button>
              <button pButton type="button" label="Update Selected Records" class="p-button-primary"
                [disabled]="isProcessingConflicts || getSelectedCount() === 0" [loading]="isProcessingConflicts"
                (click)="resolveConflicts()">
              </button>
            </div>
          </ng-template>
        </p-dialog>
        <!-- Clear Tables Password Confirmation Dialog -->
        <p-dialog header="⚠️ Clear All Workflow Data" [(visible)]="showClearConfirmDialog" [modal]="true"
          [closable]="!isClearing" [draggable]="false" [resizable]="false" styleClass="clear-confirm-dialog"
          [style]="{ width: '450px' }" (onHide)="closeClearConfirmDialog()">

          <div class="clear-confirm-content">

            <!-- Danger Warning -->
            <div class="danger-warning-message">
              <i class="pi pi-exclamation-triangle" style="color: var(--red-500); font-size: 2rem;"></i>
              <div class="warning-text">
                <strong>This action is irreversible!</strong>
                <p>All workflow data and tables will be <strong>permanently deleted</strong> from the system database.
                  This operation <strong>cannot be undone.</strong></p>
              </div>
            </div>

            <!-- Password Input Section -->
            <div class="password-section" *ngIf="!isClearing">
              <label for="clearPassword" class="password-label">
                <i class="pi pi-lock"></i>
                Enter your password to confirm:
              </label>
              <p-password id="clearPassword" [(ngModel)]="clearConfirmPassword" [feedback]="false" [toggleMask]="true"
                placeholder="Enter your password" styleClass="clear-password-input" [style]="{ width: '100%' }"
                (keydown.enter)="confirmClearTables()" [ngClass]="{ 'ng-invalid ng-dirty': clearPasswordError }">
              </p-password>
              <!-- Password Error -->
              <small class="password-error" *ngIf="clearPasswordError">
                <i class="pi pi-times-circle"></i>
                {{ clearPasswordError }}
              </small>
            </div>

            <!-- Clearing Progress -->
            <div class="clearing-progress" *ngIf="isClearing">
              <div class="warning-message">
                <i class="pi pi-exclamation-triangle" style="color: var(--orange-500);"></i>
                <span><strong>Important:</strong> Please do not close this window while clearing is in progress.</span>
              </div>
              <div class="status-message" style="margin-top: 1rem;">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Clearing all workflow data...</span>
              </div>
            </div>

            <!-- Success Message -->
            <div class="success-message" *ngIf="clearSuccess">
              <i class="pi pi-check-circle" style="color: var(--green-500);"></i>
              <span>All data cleared successfully!</span>
            </div>

            <!-- API Error Message -->
            <div class="error-message" *ngIf="clearError">
              <i class="pi pi-exclamation-triangle" style="color: var(--red-500);"></i>
              <span>{{ clearError }}</span>
            </div>

          </div>

          <!-- Dialog Footer -->
          <ng-template pTemplate="footer">
            <div class="dialog-footer">
              <button pButton type="button" label="Cancel" class="p-button-secondary" [disabled]="isClearing"
                (click)="closeClearConfirmDialog()">
              </button>
              <button pButton type="button" label="Clear All Data" icon="pi pi-trash" class="p-button-danger"
                [disabled]="isClearing || !clearConfirmPassword" [loading]="isClearing" (click)="confirmClearTables()">
              </button>
            </div>
          </ng-template>

        </p-dialog>

      </div>
    </div>

    <!-- <app-quotation-footer></app-quotation-footer> -->
  </div>